const analytics = 'analytics';
const lenders = 'lenders';
const vehicleConfiguration = 'vehicleconfiguration';

type Resource = {
  controller: string;
  resource: string;
  version: number;
};

const GetAutocheckReport: Resource = {
  controller: vehicleConfiguration,
  resource: 'autocheckreport',
  version: 3
};

const GetInHouseStockImage: Resource = {
  controller: vehicleConfiguration,
  resource: 'imageforYMMT',
  version: 5
};

const GetLenders: Resource = {
  controller: lenders,
  resource: '',
  version: 4
};

const GetLenderDetails = (lenderName: string): Resource => ({
  controller: lenders,
  resource: lenderName,
  version: 4
});

const GetUnsupportedLenders: Resource = {
  controller: lenders,
  resource: 'GetUnsupportedLenders',
  version: 4
};

const RecordAnalytics: Resource = {
  controller: analytics,
  resource: '',
  version: 4
};

export type AxiosResponse<T> = {
  data: {
    content: T;
  };
};

export type ResultStatus = 'Succeeded' | 'InvalidRequest' | 'MissingResource';

export type Result<T> = {
  content?: T | null;
  errorMessage?: string | null;
  status?: string;
};

export {
  GetAutocheckReport,
  GetInHouseStockImage,
  GetLenders,
  GetUnsupportedLenders,
  GetLenderDetails,
  RecordAnalytics
};
